import { useGitGraphQlQuery } from '@common/ExternalGitStatus/useExternalGitStatus';
import { versionsQuery } from '@common/queries/git';
import { GitQueryKeys } from '@common/queries/GitQueryKeys';

import { useGitQueryDefaultErrorHandler } from './useGitQueryDefaultErrorHandler';

export const useVersionQuery = (projectId: string) => {
  const onError = useGitQueryDefaultErrorHandler(projectId);
  return useGitGraphQlQuery(
    GitQueryKeys.Versions,
    versionsQuery,
    { onError: onError },
    // TODO: make sure to remove this once the backend is updated
    // @ts-ignore
    { projectId, excludeMergeCommits: true }
  );
};
